export const TRAINING_DATA_SHAPES = {
  SHAPE_1_HOUR: [
    0.7465393981786248,
    0.8435454964488889,
    0.7017897223434013,
    0.2116115094676949,
    0.5522891501343581,
    0.39489531676936407,
    0.31645495649902067,
    0.237388735227404,
    0.38262782192437994,
    0.6932771891758234,
    0.6775240817297499,
    0.781413387014481,
    0.7550266821328564,
    0.036610757004806205,
    0.058291690909738625,
    0.21711368166257938,
    0.09105243489227322,
    0.5157789767048915,
    0.6469797693212114,
    0.5877168494584117,
    0.7833669062104973,
    0.8415097038784631,
    0.8090034135779884,
    0.7544663139419852,
    0.7602536735235781,
    1,
    0.8196638920327688,
    0.7162934336646885,
    0.6059237331373046,
    0.7458624955716928,
    0.7746799033351859,
    0.6123853252269742,
    0.7413786513830589,
    0.6813208717920671,
    0.6879452701094708,
    0.16034578560353197,
    -1,
    -0.5935025123135109,
    0.3022291605000431,
    0.5013440871913581,
  ],
  SHAPE_3_HOURS: [
    0.16524339702772606,
    0.3556767644028027,
    1,
    0.004087745071583715,
    0.4901463528833938,
    -0.026517136068863967,
    0.3757323786850788,
    0.00007670937560444457,
    0.4089759664283401,
    -0.2082788876666649,
    -0.453814000607885,
    0.2542254123993044,
    0.3112499302381839,
    -0.9180246474949485,
    -1,
    0.2270429881792153,
    -0.7587271131609977,
    0.5348440956523766,
    0.13157759671848868,
    0.04382260220381973,
    0.4296176947736938,
    -0.024527412751015776,
    -0.7781257373735007,
    0.5399325349012527,
    -0.05115335642457186,
    0.3385955066477011,
    0.2994820533945677,
    -0.2564595063348106,
    -0.08559161899896006,
    0.7798751050591144,
    0.5899624094312175,
    0.6823864760893086,
    0.2332320064038642,
    0.3152481842803023,
    0.4421536344388768,
    0.598783257148956,
    -0.48165510832519853,
    0.01912353063121719,
    -0.8682557062965928,
    0.49236707384831635,
  ],
  SHAPE_10_HOURS: [
    1,
    0.8024991273492905,
    0.6902500485976042,
    0.28917619438773956,
    0.45375495120656706,
    0.49682417919301547,
    0.1442825074056382,
    0.44869986552938124,
    0.39715179391475863,
    0.7859655648784227,
    0.0677899021794448,
    0.801335536508123,
    0.23145535892231983,
    -0.6887478038648744,
    -0.9494376083117569,
    -0.0035105358669146325,
    -0.6633544547958081,
    -0.1569238380002148,
    0.13101870258601878,
    0.1341828284107056,
    -0.1766404652884519,
    0.23382637589665944,
    -0.20819767207412176,
    -0.09183464028706256,
    0.1567277563499574,
    -0.5319816282298537,
    0.021754779738894836,
    -0.3313368357004792,
    -0.18918408190642022,
    0.33926190753517305,
    0.5421232194342818,
    0.06935906226282484,
    -0.17764413762358477,
    0.48646339813627737,
    0.44759502691508257,
    -0.24558129962269937,
    -1,
    -0.19222151125028852,
    -0.24328394433076006,
    0.13938537977681653,
  ],
};
